import React from "react";
import loadable from "@loadable/component";

export default {
	component: loadable(() => import(/* webpackChunkName: "photoSlider" */ "./PhotoSlider.js"), {
		fallback: <div>Loading...</div>
	})
};

export const JdPhotoSlider = {
	component: loadable(() => import(/* webpackChunkName: "jd-photo-slider" */ "./JdPhotoSlider.js"), {
		fallback: <div>Loading...</div>
	})
}
